import { render, staticRenderFns } from "./piratedriver.modal.vue?vue&type=template&id=04684438&scoped=true"
import script from "./piratedriver.modal.vue?vue&type=script&lang=js"
export * from "./piratedriver.modal.vue?vue&type=script&lang=js"
import style0 from "./piratedriver.modal.vue?vue&type=style&index=0&id=04684438&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04684438",
  null
  
)

export default component.exports